var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFavoriteOutlineLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icn-favorite-outline-lg_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn-favorite-outline-lg_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.345 20.164a1.52 1.52 0 01-.57-.361l-1.437-1.306a65.865 65.865 0 01-4.748-4.764C3.197 12.172 2.5 10.502 2.5 8.72c0-1.42.478-2.607 1.436-3.565C4.893 4.199 6.08 3.72 7.5 3.72c.806 0 1.603.186 2.39.558.786.372 1.49.975 2.11 1.811.62-.836 1.324-1.44 2.11-1.811a5.542 5.542 0 012.39-.558c1.42 0 2.607.478 3.564 1.435.957.958 1.436 2.146 1.436 3.565 0 1.801-.708 3.49-2.125 5.068a63.799 63.799 0 01-4.739 4.724l-1.42 1.29a1.511 1.511 0 01-.575.362c-.22.077-.437.115-.65.115-.215 0-.43-.038-.646-.115zm-.064-12.556c-.541-.824-1.11-1.428-1.709-1.812-.598-.384-1.289-.576-2.072-.576-1 0-1.833.333-2.5 1s-1 1.5-1 2.5c0 .803.259 1.642.776 2.517a16.273 16.273 0 001.948 2.612 35.68 35.68 0 002.54 2.536c.911.826 1.756 1.593 2.534 2.302a.294.294 0 00.202.077.294.294 0 00.202-.077c.778-.709 1.623-1.476 2.534-2.302a35.667 35.667 0 002.54-2.536 16.273 16.273 0 001.948-2.612c.517-.875.776-1.714.776-2.517 0-1-.333-1.833-1-2.5s-1.5-1-2.5-1c-.783 0-1.474.192-2.072.576-.598.384-1.168.988-1.709 1.813a.818.818 0 01-.319.288.885.885 0 01-.8 0 .818.818 0 01-.32-.288z",
    fill: "#1C1B1F"
  }))));
}
export default SvgIcnFavoriteOutlineLg;